import React from 'react'
import PropTypes from 'prop-types'

const LabeledField = ({ value, label }) => {
  if (!value) {
    return null
  }

  return (
    <div className="labeled-field">
      <span className="labeled-field__label">
        {label}:&nbsp;
      </span>
      {value}
    </div>
  )
}

LabeledField.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
}

export default LabeledField
